import $ from "jquery"
import "magnific-popup"
import { hasNativeLazyLoadSupport } from "gatsby-plugin-image/dist/components/hooks";

export default function main() {
  /*Page Loader active
    ========================================================*/
    
    //===== Prealoder

    $(window).on('load', function(event) {
        $('#preloader').delay(500).fadeOut(500);
    });

  //===== Sticky
    
    $(window).on('scroll', function(event) {    
        var scroll = $(window).scrollTop();
        if (scroll < 20) {
            $(".navigation").removeClass("sticky");
        } else{
            $(".navigation").addClass("sticky");
        }
    });
    
    
    //===== Section Menu Active

    function setActivePage() {
        $(".page-separate").each(function () {
            if (
              $(this).attr("href").replace(/\/+$/, "") ===
              window.location.pathname.replace(/\/+$/, "")
            ) {
                $(this).parent().addClass("active")
                $(this).parent().siblings().removeClass("active")
            }
        })
    }
    setActivePage()
    var scrollLink = $(".page-scroll")
    // Active link switching
    $(window).scroll(function () {
        setActivePage()

        var scrollbarLocation = $(this).scrollTop()
        scrollLink.each(function (index) {
            var sectionOffset =
              $(this.hash).offset() && $(this.hash).offset().top - 73

            if (sectionOffset <= scrollbarLocation) {
                $(this).parent().addClass("active")
                $(this).parent().siblings().removeClass("active")
            }
        })
    })

    
    //===== close navbar-collapse when a  clicked
    
    $(".navbar-nav a").on('click', function () {
        $(".navbar-collapse").removeClass("show");
    });
    
    
    //===== Mobile Menu
    
    $(".navbar-toggler").on('click', function(){
        $(this).toggleClass("active");
    });
    
    $(".navbar-nav a").on('click', function() {
        $(".navbar-toggler").removeClass('active');
    });
      

    /* ==========================================================================
       countdown timer
       ========================================================================== */
     $('#clock').countdown('2022/05/14 12:30:00',function(event){
      $(this).html(event.strftime(''
      +'<div class="time-entry days"><span>%-D</span> Days</div> '
      +'<div class="time-entry hours"><span>%H</span> Hours</div> '
      +'<div class="time-entry minutes"><span>%M</span> Minutes</div> '
      +'<div class="time-entry seconds"><span>%S</span> Seconds</div> '));
    });


      /* WOW Scroll Spy
    ========================================================*/
    // var wow = new WOW({
    //  //disabled for mobile
    //    mobile: false
    //});
    //wow.init();

    /* Nivo Lightbox 
    ========================================================*/
    //$('.lightbox').nivoLightbox({
    //    effect: 'fadeScale',
    //    keyboardNav: true,
    //  });


    /* Back Top Link active
    ========================================================*/ 
    
    
    // Show or hide the sticky footer button
    $(window).on('scroll', function(event) {
        if($(this).scrollTop() > 900){
            $('.back-to-top').fadeIn(200)
        } else{
            $('.back-to-top').fadeOut(200)
        }
    });
    
    
    //Animate the scroll to yop
    $('.back-to-top').on('click', function(event) {
        event.preventDefault();
        
        $('html, body').animate({
            scrollTop: 0,
        }, 1500);
    });

    //jQuery for page scrolling feature
    $(function () {
        $('a.page-scroll[href*="#"]:not([href="#"])').on("click", function () {
            if (
              window.location.pathname.replace(/^\//, "") ===
              this.pathname.replace(/^\//, "") &&
              window.location.hostname === this.hostname
            ) {
                var target = $(this.hash)
                target = target.length ? target : $("[name=" + this.hash.slice(1) + "]")
                if (target.length) {
                    $("html, body").scrollTop(target.offset().top - 60)
                    return false
                }
            }
        })
    })

    /* Timetable popup
    ========================================================*/
    function findReactComponent(el) {
        for (const key in el) {
            if (key.startsWith('__reactFiber$')) {
                const fiberNode = el[key];

                return fiberNode && fiberNode.return && fiberNode.return.stateNode;
            }
        }
        return null;
    }

    var popupParams = {
        type: 'inline',
        closeOnContentClick: false,
        midClick: true,
        zoom: {
            enabled: true,
            duration: 500, // don't foget to change the duration also in CSS
        },
        mainClass: 'mfp-fade',
        callbacks: {
            beforeOpen: function() {
                if (this.st.el) {
                    window.location.hash = this.st.el[0].hash
                    this.st.mainClass = this.st.el.attr('data-effect')
                }
            },
            open: function() {
                // Workaround for images in the popup not showing up in Safari
                this.content[0].querySelectorAll('.gatsby-image-wrapper').forEach(function(target) {
                    if (hasNativeLazyLoadSupport())
                        return;

                    const component = findReactComponent(target);
                    component.componentWillUnmount()
                    component.forceRender.current = true
                });
                // Lazily load iframe contents as workaround for crashing in mobile
                this.content.find('[data-youtube-url]').each(function() {
                    this.innerHTML = `<iframe width="100%" src="${this.dataset.youtubeUrl}" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>`;
                    delete this.dataset.youtubeUrl;
                });
                this.content.find('[data-slide-url]').each(function() {
                    this.innerHTML = `<iframe src="${this.dataset.slideUrl}" width="100%" frameBorder="0" allowTransparency="true" allowFullScreen="allowfullscreen" mozallowfullscreen="true" webkitallowfullscreen="true"></iframe>`;
                    delete this.dataset.slideUrl;
                });
            },
            close: function() {
                window.location.hash = ''
            }
        },
    }
    $('body').magnificPopup(
      Object.assign(
        {
            delegate: 'a.popup',
        },
        popupParams
      )
    )
    // auto-open
    if (window.location.hash) {
        if ($(window.location.hash + '.schedule-popup').length > 0) {
            $.magnificPopup.open(
              Object.assign(
                {
                    items: {
                        src: window.location.hash,
                    },
                    mainClass: 'mfp-zoom-in',
                },
                popupParams
              )
            )
        } else {
            // Workaround for opening the page with hash not scrolling
            var hash = window.location.hash
            window.location.hash = ''
            window.location.hash = hash
        }
    }
}